<div class="form-group" [ngClass]="additionalGroupClass" [class.form-group-disabled]="selectControl?.status === 'DISABLED'">
    @if (label) {
        <label [for]="idAttrValue">
            {{ label }}
            @if (isRequiredField) {
                <sup>*</sup>
            }
        </label>
    }

    <ng-select
        class="ng-select--form-control"
        [ngClass]="size ? 'ng-select--' + size : null"
        [addTag]="addTag"
        [clearable]="clearable"
        [searchable]="searchable"
        [labelForId]="idAttrValue"
        [addTagText]="addTagText | translate"
        [clearAllText]="'global.actions.clear' | translate"
        [notFoundText]="'global.labels.no_items_found' | translate"
        [items]="options"
        [placeholder]="placeholder"
        [readonly]="selectControl?.status === 'DISABLED'"
        [formControl]="selectControl"
        [class.ng-select--loading]="!options"
        [multiple]="multiple"
        [bindLabel]="bindLabel"
        [bindValue]="bindValue">
        @if (translateOptions) {
            <ng-template ng-label-tmp let-item="item">
                <span class="ng-value-label">{{ item?.[bindLabel] | translate }}</span>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
                {{ item?.[bindLabel] | translate }}
            </ng-template>
        }
    </ng-select>

    @if (selectControl?.errors && selectControl?.touched) {
        <div class="invalid-feedback">
            <span class="invalid-feedback-box">{{ selectControl.errors | validationMessage }}</span>
        </div>
    }
</div>
